import { AppFolioConnectForm } from './AppFolioConnectForm'
import type { VendorConnectorProps } from './types'

/**
 * Onboarding-side mount for AppFolio. Renders the SAME form component that
 * Settings' AppFolioIntegrationPage mounts. Any change to the AppFolio connect
 * flow happens in AppFolioConnectForm — both mount points pick it up.
 */
export function AppFolioConnector({ onConnected }: VendorConnectorProps) {
  return <AppFolioConnectForm onConnected={() => onConnected?.()} />
}
